import React, { useEffect, useState } from 'react'
import { WrapperDaftarTugas, ListTugas } from '../dashboard-employee.elements'
import FormTambahTugas from './FormTambahTugas'
import API from '../../../../config/api';
import { Actions, ButtonDelete, ButtonEdit, Card, Content, Description, TaskContainer, TitleTugas } from '../components/tambahTugas';
import { Loading } from '../../../../components';

//nanti refactor kode ini supaya bisa digunakan di mana aja
const DaftarTugas = ({ setOpenmodal, setData, status, search, ticket, setTicket, getTicket, setTypeModal }) => {
    const [todos, setTodos] = useState([]);
    const [text, setText] = useState({});
    const [edit, setEdit] = useState({
        id: null,
        value: ''
    });
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(false)


    const addTodo = todo => {
        if (!todo.text || /^\s*$/.test(todo.text)) {
            return;
        }

        const newTodo = [todo, ...todos];

        setTodos(newTodo);
        // console.log(todo, ...todos)
    }

    const completeTodo = id => {
        let updatedTodos = todos.map(todo => {
            if (todo.id === id) {
                todo.isComplete = !todo.isComplete;
            }
            return todo;
        })

        setTodos(updatedTodos);
    }

    const updateTodo = (todoId, newValue) => {
        // console.log(newValue)

        if (!newValue.text || /^\s*$/.test(newValue.text)) {
            return;
        }

        setTodos(prev => prev.map(item => (item.id === todoId ? newValue : item)));
    }

    const submitUpdate = value => {
        updateTodo(value.id, value);
        setEdit({
            id: null,
            value: ''
        })
    }

    if (edit.id) {
        // console.log(`isi form tambah itu dengan ${edit}`);
        setText(edit)
        setEdit({
            id: null,
            value: ''
        })
    }

    const handleEdit = (item) => {
        setOpenmodal(true)
        setData(item)
    }
    const handleDelete = (row) => {
        // console.log(row)
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this task!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    setLoading(true)
                    return API.deleteTicket(token, row.id).then(res => {
                        // console.log('Call API delete Departemen');
                        getTicket()
                        swal({
                            title: 'Berhasil',
                            text: 'Ticket berhasil dihapus',
                            icon: "success",
                        });
                        setLoading(false);
                    }).catch(err => {
                        console.log(err);
                        setLoading(false);
                    })
                }
                else {
                    //   swal("Your imaginary file is safe!");
                    setLoading(false);

                }
            });
    }



    return (
        <>
            <FormTambahTugas onSubmit={addTodo} value={text} submitUpdate={submitUpdate} setOpenmodal={setOpenmodal} getTicket={getTicket} />

            <TaskContainer>
                {
                    ticket?.map((todo, index) => (
                        <Card key={index} style={{ marginBottom: ticket?.length - 1 === index ? '50px' : '0px' }} className={todo?.status}>
                            <Content onClick={() => {
                                setTypeModal('Detail')
                                setOpenmodal(true)
                                setData(todo)
                            }}>
                                <TitleTugas>{todo?.title}</TitleTugas>
                                <Description>{todo?.description}</Description>
                            </Content>
                            <Actions>
                                <ButtonEdit onClick={() => handleEdit(todo)}>Edit</ButtonEdit>
                                <ButtonDelete onClick={() => handleDelete(todo)}>Hapus</ButtonDelete>
                            </Actions>
                        </Card>

                    ))
                }
                {/* <div className="left-cont">
                    <input type="checkbox" id="check-1" name="" />
                    <label for="check-1"></label>   
                    <span>Tugas 1</span>
                </div>
                <span className="hapus-tugas">Hapus</span> */}
                {loading && <Loading />}
            </TaskContainer>
        </>
    )
}

export default DaftarTugas
